class RecruitmentProcess {
    constructor(rootElement) {
        this.rootElement = rootElement;
        this.container = rootElement.querySelector('#recruitment-process-steps');
        this.steps = Array.from(this.container.querySelectorAll('.recruitment-process__step'));

        this.prevButton = rootElement.querySelector('.recruitment-process__button--back');
        this.nextButton = rootElement.querySelector('.recruitment-process__button--forward');

        this.leftOffset = parseFloat(getComputedStyle(this.container).paddingLeft) || 0;

        this.prevButton.addEventListener('click', () => {
            this.scrollToPrevious();
        });

        this.nextButton.addEventListener('click', () => {
            this.scrollToNext();
        });

        this.container.addEventListener('scroll', () => this.updateButtonState());
        window.addEventListener('resize', () => this.handleResize());

        this.updateButtonState();
    }

    handleResize() {
        this.leftOffset = parseFloat(getComputedStyle(this.container).paddingLeft) || 0;
        this.updateButtonState();
    }

    scrollToNext() {
        const containerRect = this.container.getBoundingClientRect();
        const next = this.steps.find(step => {
            const rect = step.getBoundingClientRect();
            return rect.left - containerRect.left > 1;
        });

        if (next) {
            this.container.scrollTo({
                left: next.offsetLeft - this.leftOffset,
                behavior: 'smooth'
            });
        }
    }

    scrollToPrevious() {
        const containerRect = this.container.getBoundingClientRect();
        const reversed = [...this.steps].reverse();
        const prev = reversed.find(step => {
            const rect = step.getBoundingClientRect();
            return rect.right - containerRect.left < -1;
        });

        if (prev) {
            this.container.scrollTo({
                left: prev.offsetLeft - this.leftOffset,
                behavior: 'smooth'
            });
        }
    }

    updateButtonState() {
        const scrollLeft = this.container.scrollLeft;
        const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;

        this.prevButton.disabled = scrollLeft <= this.leftOffset + 1;
        this.nextButton.disabled = scrollLeft >= maxScrollLeft - 1;
    }
}


document.addEventListener('DOMContentLoaded', function () {
    const rootElements = [...document.querySelectorAll('.recruitment-process')];

    rootElements.forEach(rootElement => {
        new RecruitmentProcess(rootElement);
    });
});
